import { makeStyles } from '@material-ui/core/styles';
import Themes from './Themes';

/**
 * Global styles only.  Component-specific styles should be defined in a component-specific file.
 */
export const useThemeStyles = makeStyles(() => ({
    '@global': {
        'html, body': {
            '& .MuiButton-containedSecondary': {
                color: Themes.light.palette.text.primary,
            },
        },
        // Interface-specific styles for monitored interface list
        '.device-disabled-interface': {
            opacity: 0.5,
        },
        '.bold-text': {
            fontWeight: 'bold',
        },
    },
}));

export default useThemeStyles;
